import { render, staticRenderFns } from "./DetailContainer.vue?vue&type=template&id=37034e08&scoped=true&"
import script from "./DetailContainer.vue?vue&type=script&lang=js&"
export * from "./DetailContainer.vue?vue&type=script&lang=js&"
import style0 from "./DetailContainer.vue?vue&type=style&index=0&id=37034e08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37034e08",
  null
  
)

export default component.exports